// Calendar.js

import React, { useState , useRef, useEffect} from 'react';
import './calendarForDiscussAndLearn.css';
import StrangersList from '../miscellaneous/StrangersList/StrangersList';
import FriendsList from '../miscellaneous/FriendsList/FriendsList';
import { Link } from "react-router-dom";

import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import Paper from '@mui/material/Paper';
import { Height } from '@mui/icons-material';

import { CgCheck } from "react-icons/cg";    // Check mark overlaying the profile pic. 
// import { IoIosCheckmark } from "react-icons/io";
// import { BsCheck } from "react-icons/bs";

import { MdExpandCircleDown } from "react-icons/md";
import { MdOutlineExpandCircleDown } from "react-icons/md";

import { CiSearch } from "react-icons/ci";

import { MdPushPin } from "react-icons/md";

import { IoMdClose } from "react-icons/io";

//----------------------------------------------------------------------------------------

/*
console.log("todayyyy : "+today);
console.log("todayyyy : " + today.format("YYYY-MM-DD HH:mm:ss"));
console.log("today's day name' : " + today.format("dddd"));    //day name.
//weekdayName = today.format("dddd");
console.log("today's date : " + today.format("DD"));

//weekdayName = today.format("dd");

const date = today.format("DD");   //date number.
const tomorrow = today.add(1, 'day').format('YYYY-MM-DD');
console.log("tomorrow's date :"+tomorrow);

const weekdayDates = [];

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];*/


/*
if('Monday'===today.format("dddd") ){
  const mondayDate =  today.format("DD");
  const tuesdayDate =  today.add(1, 'day').format('DD');
  const wednesdayDate =  today.add(2, 'day').format('DD');
  const thursdayDate =  today.add(3, 'day').format('DD');
  const fridayDate =  today.add(4, 'day').format('DD');
  const saturdayDate =  today.add(5, 'day').format('DD');
  const sundayDate =  today.add(6, 'day').format('DD');
}else if ('Tuesday'===today.format("dddd")){
  const mondayDate =  today.subtract(1, 'day').format('DD');
  const tuesdayDate =  today.format("DD");
  const wednesdayDate =  today.add(1, 'day').format('DD');
  const thursdayDate =  today.add(2, 'day').format('DD');
  const fridayDate =  today.add(3, 'day').format('DD');
  const saturdayDate =  today.add(4, 'day').format('DD');
  const sundayDate =  today.add(5, 'day').format('DD');
}else if ('Wednesday' === today.format("dddd")) {
  const mondayDate = today.subtract(2, 'days').format('DD');
  const tuesdayDate = today.subtract(1, 'day').format('DD');
  const wednesdayDate = today.format("DD");
  const thursdayDate = today.add(1, 'day').format('DD');
  const fridayDate = today.add(2, 'day').format('DD');
  const saturdayDate = today.add(3, 'day').format('DD');
  const sundayDate = today.add(4, 'day').format('DD');
} else if ('Thursday' === today.format("dddd")) {
  const mondayDate = today.subtract(3, 'days').format('DD');
  const tuesdayDate = today.subtract(2, 'days').format('DD');
  const wednesdayDate = today.subtract(1, 'day').format('DD');
  const thursdayDate = today.format("DD");
  const fridayDate = today.add(1, 'day').format('DD');
  const saturdayDate = today.add(2, 'day').format('DD');
  const sundayDate = today.add(3, 'day').format('DD');
} else if ('Friday' === today.format("dddd")) {
  const mondayDate = today.subtract(4, 'days').format('DD');
  const tuesdayDate = today.subtract(3, 'days').format('DD');
  const wednesdayDate = today.subtract(2, 'day').format('DD');
  const thursdayDate = today.subtract(1, 'day').format('DD');
  const fridayDate = today.format("DD");
  const saturdayDate = today.add(1, 'day').format('DD');
  const sundayDate = today.add(2, 'day').format('DD');
} else if ('Saturday' === today.format("dddd")) {
  const mondayDate = today.subtract(5, 'days').format('DD');
  const tuesdayDate = today.subtract(4, 'days').format('DD');
  const wednesdayDate = today.subtract(3, 'day').format('DD');
  const thursdayDate = today.subtract(2, 'day').format('DD');
  const fridayDate = today.subtract(1, 'day').format('DD');
  const saturdayDate = today.format("DD");
  const sundayDate = today.add(1, 'day').format('DD');
} else if ('Sunday' === today.format("dddd")) {
  const mondayDate = today.subtract(6, 'days').format('DD');
  const tuesdayDate = today.subtract(5, 'days').format('DD');
  const wednesdayDate = today.subtract(4, 'day').format('DD');
  const thursdayDate = today.subtract(3, 'day').format('DD');
  const fridayDate = today.subtract(2, 'day').format('DD');
  const saturdayDate = today.subtract(1, 'day').format('DD');
  const sundayDate = today.format("DD");
}*/





//----------------------------------------------------------------------------
function CalendarForDiscussAndLearn(props) {
  const [dates, setDates] = useState([]);
  const today = dayjs();
  const monthAndYear = today.format('MMMM YYYY');

  //------------Setting the dates for calendar head------------
  useEffect(()=>{
    const today = dayjs();
    let indexOfWeekday = today.day();          // 0 for Sunday, 1 for Monday, ..., 6 for Saturday.
    indexOfWeekday = (indexOfWeekday + 6) % 7;      // To make it like - 0 for Monday, 1 for tuesday, 2 for wednesday, 3 for thursday, 4 for friday, 5 for saturday and 6 for sunday.    
    let datesArray = [];
  
    //let dates = [];
    for (let i = 0; i < 7; i++) {
      datesArray.push(today.subtract(indexOfWeekday - i, 'day').format('DD'));
    }
    setDates(datesArray);
  },[]);      // Only re-run the effect if this second parameter changes. Here we have to give a state if we are to give something. If nothing given (as in if it is left blank), it will re-run the effect everytime there is some change (any change).

  const weekdayNamesAndDates = [['Monday',dates[0]], ['Tueday',dates[1]], ['Wednesday',dates[2]], ['Thursday',dates[3]], ['Friday',dates[4]], ['Saturday',dates[5]], ['Sunday',dates[6]]];
  //-----------------------------------------------------------
  //handleArrowClick function.
  
  function handleArrowClick(event){
    if(event.currentTarget.className === 'cfdal_weekday_shift_left_arrow'){   //I don't know why it can't be "e.target.className".
      //console.log("left");
    }else if(event.currentTarget.className === 'cfdal_weekday_shift_right_arrow'){
      //console.log("right");
    }
  }

  //-----------------------------------------------------------
  const multiplesOf7 = Array.from({ length: 101 }, (_, index) => index * 7);    //till 707.
  const multiplesOf4 = Array.from({ length: 177 }, (_, index) => index * 4);
  const multiplesOf9 = Array.from({ length: 100 }, (_, index) => (index + 1) * 9);   //till 899.
  const multiplesOf8 = Array.from({ length: 112 }, (_, index) => (index + 1) * 8);   //till 899.
  const multiplesOf8WithOneLess = Array.from({ length: 112 }, (_, index) => (index + 1) * 8 - 1);

  const combinedArrayOf8And8Minus1 = [...multiplesOf8, ...multiplesOf8WithOneLess];
  const multiplesOf9WithOneLess = Array.from({ length: 100 }, (_, index) => (index + 1) * 9 - 1);

  const combinedArrayOf9And9Minus1 = [...multiplesOf9, ...multiplesOf9WithOneLess];

  // firstAndLastColumnArray is for the sequence array for rendering items for the first and last column.
  const firstAndLastColumnArray = Array.from({ length: 450 }, (_, index) => {
    const baseNumber = Math.floor(index / 2) * 9;
    return index % 2 === 0 ? baseNumber : baseNumber + 8;
  });

  //first column array sequence.
  const firstColumnArray = Array.from({ length: 100 }, (_, index) => index * 9);     // [0,9,18,27,...,891] till 899. There are 900 grids. The index of last grid is 899.

  const lastColumnArray = Array.from({ length: 100 }, (_, index) => 8+index * 9);

  const timeSlotsArray = [];
  for (let hour = 0; hour <= 23; hour++) {
    for (let minute = 0; minute <= 45; minute += 15) {
      const formattedHour = (hour % 12 === 0) ? 12 : hour % 12; // Convert 0 and 12 to 12
      const amPm = (hour < 12) ? 'AM' : 'PM';
  
      const timeString = (minute === 0) ? `${formattedHour} ${amPm}` : minute;
  
      timeSlotsArray.push(timeString);
    }
  }

  const hourBorderLineSequenceArray = [];
  for (let i = 28; i <= 899; i += 36) {                  //900 should be the total till 1 AM at the bottom. But even if I give 900 it is not rendering a line at the bottom most line.
    for (let j = 0; j < 7; j++) {
      hourBorderLineSequenceArray.push(i + j);
    }
  }

  const [highlightedGrids, setHighlightedGrids] = useState([]);
  const [topAndBottomGrids, setTopAndBottomGrids] = useState([]);
  const [heightOfCalendarGrid, setHeightOfCalendarGrid] = useState(0);

  const [hoveredGrid, setHoveredGrid] = useState([]);
  const [from1145pmTo12amHoveredGrid, setFrom1145pmTo12amHoveredGrid] = useState([]);

  const [clickedGrid, setClickedGrid] = useState([]);
  const [from1145pmTo12amClickedGrid, setFrom1145pmTo12amClickedGrid] = useState([]);


  const panelDivRef = useRef(null);   // -------------useRef---------------
  //const heightOfCalendarGrid = panelDivRef.current.offsetHeight;   //var or const ?

  useEffect(() => {    //--------For getting the calendar grid height for rendering the overlay booking box---------
    // Update the textarea height whenever the text changes
    if (panelDivRef.current) {
      //console.log(panelDivRef.current);
      // console.log("panel div height : "+ panelDivRef.current.style.height);     //Not the right way.
      //console.log("panel div height : "+ panelDivRef.current.offsetHeight);   //The hight of each calendar grid.
      setHeightOfCalendarGrid(panelDivRef.current.offsetHeight);   //var or const ?
    }
  },[]);     // Only re-run the effect if this second parameter changes. Here we have to give a state if we are to give something. If nothing given (as in if it is left blank), it will re-run the effect everytime there is some change (any change).

  function handleMouseOver(ind){
    if (ind<854){
      setHoveredGrid([ind]);
    }else if (ind > 854 && ind < 863){
      setFrom1145pmTo12amHoveredGrid([ind]);
    }
  }

  function handleMouseOut(){
    setHoveredGrid([]);
    setFrom1145pmTo12amHoveredGrid([]);
  }

  function handleGridClick(index){
    if (index<854){
      setClickedGrid([index]);
      setFrom1145pmTo12amClickedGrid([]);    //Empty the other one.
    }else if (index > 854 && index < 863){
      setFrom1145pmTo12amClickedGrid([index]);
      setClickedGrid([]);                    //Empty the other one.
    }
  }

  const [clickedSubject, setClickedSubject] = useState('mechanical');
  function handleSubjectClick(e){
    //console.log("subject: " + e.currentTarget.textContent);
    //console.log("subject: " + e.currentTarget.getAttribute('name'));
    setClickedSubject(e.currentTarget.getAttribute('name'));
  }

  //-----Display subject expansion or not  (Down)----------------
  
  const [clickedExpand, setClickedExpand] = useState(false);
  function handleSubjectExpansion(){
    if (clickedExpand===false){
      setClickedExpand(true);
    }else if (clickedExpand===true){
      setClickedExpand(false);
    }
  }

  //---
  // After adding the below it seems like it is taking too much time to load when you run "nom start".
  
  const subjectExpansionRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (subjectExpansionRef.current && !subjectExpansionRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setClickedExpand(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  //----Display subject expansion or not (up)--------------------



  //-----Display small calendar or not  (Down)----------------
  
  const [displayCalendar, setDisplayCalendar] = useState(false);
  function handleDisplayCalendar(){
    if (displayCalendar===false){
      setDisplayCalendar(true);
    }else if (displayCalendar===true){
      setDisplayCalendar(false);
    }
  }

  //---
  // After adding the below it seems like it is taking too much time to load when you run "nom start".
  const displayCalendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (displayCalendarRef.current && !displayCalendarRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setDisplayCalendar(false);
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  //----Display small calendar or not (up)--------------------

  //----searchTerm handling (down)--------------------
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  //----searchTerm handling (up)--------------------

  //----Entered topic handling (down)--------------------
  const [topic, setTopic] = useState('');

  const handleTopicChange = (event) => {
    setTopic(event.target.value);
  };
  //----Entered topic handling (up)--------------------

  //------------Handle book with a stranger (down)-------------------
  const [showStrangersList, setShowStrangersList] = useState(false);

  // After adding the below it seems like it is taking too much time to load when you run "npm start".
  const showStrangersListRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (showStrangersListRef.current && !showStrangersListRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowStrangersList(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
    };
  }, []);
  //------------Handle book with a stranger (up)-------------------


  //------------Handle book with a friend (down)-------------------
  const [showFriendsList, setShowFriendsList] = useState(false);

  // After adding the below it seems like it is taking too much time to load when you run "npm start".
  const showFriendsListRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (showFriendsListRef.current && !showFriendsListRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowFriendsList(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
    };
  }, []);
  //------------Handle book with a friend (up)-------------------

  //{(showFriendsList===true)&&(<FriendsList/>)}
  return(
    <div className='cfdal_main_div'>
      {/*----------------Render strangers list (note the class used for now is fl)--------------- */}
      {/*(showStrangersList===true)&&(<StrangersList ref={showStrangersListRef}/>)*/}
      {(showStrangersList===true)&&(<div ref={showStrangersListRef} className='sl_friends_list'>
                                    <div className="sl_title_and_close_icon_div">
                                      <h2 className="sl_h2">People</h2>
                                      <IoMdClose onClick={()=>setShowStrangersList(false)} className="sl_close_icon"/>
                                    </div>
                                    <div className='sl_person_details_div'>
                                      <div className='sl_person_avatar_name_div'>
                                        <Avatar className="sl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                        <p className='sl_person_name_class'>David Kipping</p>
                                      </div>
                                      <div className='sl_person_topic_book_button_div'>
                                        <p className='sl_person_topic_class_chosen'>Strength of materials</p>
                                        <button className="sl_strangers_book_button">
                                          Book
                                        </button>
                                      </div>
                                    </div>
                                    <div className='sl_person_details_div'>
                                      <div className='sl_person_avatar_name_div'>
                                        <Avatar className="sl_avatar_class" alt="Paul" src='/images/divya_mohan.png'/>
                                        <p className='sl_person_name_class'>Divya Mohan</p>
                                      </div>
                                      <div className='sl_person_topic_book_button_div'>
                                        <p className='sl_person_topic_class_chosen'>Strength of materials</p>
                                        <button className="sl_strangers_book_button">
                                          Book
                                        </button>
                                      </div>
                                    </div>
                                    <div className='sl_person_details_div'>
                                      <div className='sl_person_avatar_name_div'>
                                        <Avatar className="sl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                        <p className='sl_person_name_class'>Tom Christo</p>
                                      </div>
                                      <div className='sl_person_topic_book_button_div'>
                                        <p className='sl_person_topic_class'>Thermodynamics</p>
                                        <button className="sl_strangers_book_button">
                                          Book
                                        </button>
                                      </div>
                                    </div>
                                    <div className='sl_person_details_div'>
                                      <div className='sl_person_avatar_name_div'>
                                        <Avatar className="sl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                        <p className='sl_person_name_class'>Ashok Jain</p>
                                      </div>
                                      <div className='sl_person_topic_book_button_div'>
                                        <p className='sl_person_topic_class'>Dynamics of machines</p>
                                        <button className="sl_strangers_book_button">
                                          Book
                                        </button>
                                      </div>
                                    </div>
                                    <div className='sl_person_details_div'>
                                      <div className='sl_person_avatar_name_div'>
                                        <Avatar className="sl_avatar_class" alt="Urumi" src='/images/urumi.png'/>
                                        <p className='sl_person_name_class'>John</p>
                                      </div>
                                      <div className='sl_person_topic_book_button_div'>
                                        <p className='sl_person_topic_class'>Kinematics of machines</p>
                                        <button className="sl_strangers_book_button">
                                          Book
                                        </button>
                                      </div>
                                    </div>
                                    <Link className="sl_invite_friends_button" to="/invite_friends">
                                      Automatically pair me when someone of the same topic books
                                    </Link>
                                  </div>)}

      {/*----------------Render friends list  (note the class used for now is fl)--------------- */}
      {/*(showFriendsList===true)&&(<FriendsList ref={showFriendsListRef}/>)*/}
      {(showFriendsList===true)&&(<div ref={showFriendsListRef} className='fl_friends_list'>
                                    <div className="fl_title_and_close_icon_div">
                                      <h2 className="fl_h2">Friends</h2>
                                      <IoMdClose onClick={()=>setShowFriendsList(false)} className="fl_close_icon"/>
                                    </div>
                                    <div className='fl_person_details_div'>
                                      <Avatar className="fl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                      <p className='fl_person_name_class'>Ann</p>
                                      <button className="fl_friends_availability_button">
                                        Check for availability
                                      </button>
                                    </div>
                                    <div className='fl_person_details_div'>
                                      <Avatar className="fl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                      <p className='fl_person_name_class'>Meghana</p>
                                      <button className="fl_friends_availability_button">
                                        Check for availability
                                      </button>
                                    </div>
                                    <div className='fl_person_details_div'>
                                      <Avatar className="fl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                      <p className='fl_person_name_class'>Ashna</p>
                                      <button className="fl_friends_availability_button">
                                        Check for availability
                                      </button>
                                    </div>
                                    <div className='fl_person_details_div'>
                                      <Avatar className="fl_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                                      <p className='fl_person_name_class'>Chandini</p>
                                      <button className="fl_friends_availability_button">
                                        Check for availability
                                      </button>
                                    </div>
                                    <div className='fl_person_details_div'>
                                      <Avatar className="fl_avatar_class" alt="Urumi" src='/images/urumi.png'/>
                                      <p className='fl_person_name_class'>Susan</p>
                                      <button className="fl_friends_availability_button">
                                        Check for availability
                                      </button>
                                    </div>
                                    <Link className="fl_invite_friends_button" to="/invite_friends">
                                      Invite your friends
                                    </Link>
                                  </div>)}

      {/*----------------Subjects display area--------------- */}
      <div className='cfdal_subject_div'>
        {/* <SlArrowLeft className='cfdal_arrow_size'/> */}
        <div name='physics' onClick={handleSubjectClick} className={(clickedSubject==='physics')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/> <p>Physics</p></div>
        <div name='french' onClick={handleSubjectClick} className={(clickedSubject==='french')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/><p>French</p></div>
        <div name='guitar' onClick={handleSubjectClick} className={(clickedSubject==='guitar')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/><p>Guitar</p></div>
        <div name='mechanical' onClick={handleSubjectClick} className={(clickedSubject==='mechanical')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/><p>Mechanical Engineering</p></div>
        <div name='medicine' onClick={handleSubjectClick} className={(clickedSubject==='medicine')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/><p>Medicine</p></div>
        <div name='law' onClick={handleSubjectClick} className={(clickedSubject==='law')?'cfdal_clicked_subject':'cfdal_subject'}><MdPushPin className='cfdal_pin'/><p>Law</p></div>
        {/* <SlArrowRight className='cfdal_arrow_size'/> */}
      </div>

      {/*----------------Calendar top dash div--------------- */}
      <div className='cfdal_calendar_top_dash_div'>
        <p ref={displayCalendarRef} onClick={handleDisplayCalendar} className='cfdal_month_and_year_p_tag'>{monthAndYear}</p>
        {(displayCalendar===true)&&(<div className='cfdal_small_calendar'>Small calendar</div>)}
        {/* <img className="cfdal_calendar_img_show" src='/images/calendar.png'></img> */}

        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="cfdal_search_input"

          ref={subjectExpansionRef}
          onClick={handleSubjectExpansion}
        />

        {(clickedExpand===true)&&(<div className='cfdal_subject_expansion_box'>

                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>Physics</div>
                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>French</div>
                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>Guitar</div>
                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>Mechanical Engineering</div>
                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>Medicine</div>
                                    <div className='cfdal_expansion_box_subject'><MdPushPin className='cfdal_pin'/>Law</div>

                                    <hr className='cfdal_expansion_box_hr'></hr>

                                    <div className='cfdal_expansion_box_subject'>Quantum Physics</div>
                                    <div className='cfdal_expansion_box_subject'>Aerospace Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Japanese</div>
                                    <div className='cfdal_expansion_box_subject'>Mechanical Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Music</div>
                                    <div className='cfdal_expansion_box_subject'>Medicine</div>
                                    <div className='cfdal_expansion_box_subject'>German</div>
                                    <div className='cfdal_expansion_box_subject'>Computer Science</div>
                                    <div className='cfdal_expansion_box_subject'>Electronics and Communication Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Architecture</div>
                                    <div className='cfdal_expansion_box_subject'>Violin</div>
                                    <div className='cfdal_expansion_box_subject'>Civil Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Electrical Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Chemical Engineering</div>
                                    <div className='cfdal_expansion_box_subject'>Mathematics</div>
                                  </div>)}
      </div>

      {/*----------------Calendar--------------- */}

      <Grid container spacing={0} className='cfdal_calendar_main_grid'>  {/*Contains up-and-down child grids.*/}
        
        {/*----------------Calendar upper section--------------- */}

        <Grid container xs={30} columns={30} className='cfdal_calendar_upper_section_grid'>
          {/*----------------Calendar left arrow--------------- */}
          <Grid xs={1} className='cfdal_calendar_upper_section_left_arrow_panel_grid'>
            <div className='cfdal_calendar_upper_section_day_panel_div'> 
              {/*<p className='cfdal_weekday_name'>nnn</p>*/}
              <div onClick={handleArrowClick} className='cfdal_weekday_shift_left_arrow'><SlArrowLeft/></div>                 
            </div>
          </Grid>
          {/*----------------Weekday names and Calendar dates--------------- */}
          {weekdayNamesAndDates.map(function(day, index){
            return(
              <Grid key={index} id={index} xs={4.05} className='cfdal_calendar_upper_section_day_panel_grid'>
                <div className='cfdal_calendar_upper_section_day_panel_div'> 
                  <p className='cfdal_weekday_name'>{day[0]}</p>
                  <span className='cfdal_weekday_date'>{day[1]}</span>                 
                </div>
              </Grid>
            );
          })}
          {/*----------------Calendar right arrow--------------- */}
          <Grid xs={0.65} className='cfdal_calendar_upper_section_right_arrow_panel_grid'>
            <div className='cfdal_calendar_upper_section_day_panel_div'> 
              {/*<p className='cfdal_weekday_name'>mmm</p>*/}
              <div onClick={handleArrowClick} className='cfdal_weekday_shift_right_arrow'><SlArrowRight/></div>                 
            </div>
          </Grid>
        </Grid>

        {/*----------------Calendar lower section--------------- */}

        <Grid container xs={30} columns={30} className='cfdal_calendar_lower_section_grid'>
          {/*----------------Rendering 900 grids--------------- */}
          {Array.from({ length: 900 }, (_, index) => {
                {/*----------------First column--------------- */}
                if (firstColumnArray.includes(index)){         
                  return (
                    <Grid key={index} xs={1} className='cfdal_calendar_lower_section_first_column_panel_grid'>
                      <div key={index} className='cfdal_calendar_lower_section_panel_div'>
                        {((index===0)?(
                          <div className='cfdal_12AM_timeSlot'>{timeSlotsArray[(index)]}</div>    /*For the top 12 AM slot adjustment.*/
                        ):(
                          <div className='cfdal_timeSlots'>{timeSlotsArray[(index/9)]}</div>    /*For other time slots.*/
                        ))
                      }
                      </div>
                    </Grid>
                  )
                {/*----------------Last column-------------------*/}
                }else if (lastColumnArray.includes(index)){   
                  return (
                    <Grid key={index} xs={0.65} className='cfdal_calendar_lower_section_last_column_panel_grid'>
                      <div key={index} className='cfdal_calendar_lower_section_panel_div'>
                      </div>
                    </Grid>
                  )
                {/*---------------Middle columns----------------*/}
                }else{                                         
                  return(
                      /*Ternary operator should come here for hour border line with hourBorderLineSequenceArray.*/
                      (hourBorderLineSequenceArray.includes(index) ? (
                        <Grid key={index} xs={4.05} onClick={() => handleGridClick(index)} onMouseOver={() => handleMouseOver(index)} onMouseOut={handleMouseOut} className="cfdal_calendar_lower_section_hour_line_panel_grid">
                          {(hoveredGrid.includes(index)) && (<div className="cfdal_hovered_overlay" style={{height : `${6*heightOfCalendarGrid+3}px`}}><CgCheck className='cfdal_tick'/></div>)}     {/*Hovered overlay*/}
                          {(from1145pmTo12amHoveredGrid.includes(index)) && (<div className="cfdal_hovered_overlay" style={{height : `${5*heightOfCalendarGrid+3}px`}}><CgCheck className='cfdal_tick'/></div>)}     {/*Hovered overlay*/}
                          
                          {(clickedGrid.includes(index)) && (
                                                              <div className="cfdal_clicked_overlay" style={{height : `${6*heightOfCalendarGrid+3}px`}}>
                                                                <button onClick={() => setShowStrangersList(true)} className='cfdal_slot_book_any_button'> Book
                                                                </button>
                                                                <button onClick={() => setShowFriendsList(true)} className='cfdal_slot_book_friend_button'> Book with a friend
                                                                </button> 
                                                                <div className="cfdal_enter_topic_message_div">Enter topic you wish to learn in the subject before booking</div>
                                                                <input
                                                                  type="text"
                                                                  placeholder="Enter topic if any..."
                                                                  value={topic}
                                                                  onChange={handleTopicChange}
                                                                  className="cfdal_topic_input"
                                                                />      
                                                              </div>
                                                            )}                {/*Clicked overlay*/}

                          {(from1145pmTo12amClickedGrid.includes(index)) && (
                                                                              <div className="cfdal_clicked_overlay" style={{height : `${5*heightOfCalendarGrid+3}px`}}>
                                                                                <button onClick={() => setShowStrangersList(true)} className='cfdal_slot_book_any_button'> Book
                                                                                </button>
                                                                                <button onClick={() => setShowFriendsList(true)} className='cfdal_slot_book_friend_button'> Book with a friend
                                                                                </button>
                                                                                <div className="cfdal_enter_topic_message_div">Enter topic you wish to learn in the subject before booking</div>
                                                                                <input
                                                                                  type="text"
                                                                                  placeholder="Enter topic if any..."
                                                                                  value={topic}
                                                                                  onChange={handleTopicChange}
                                                                                  className="cfdal_topic_input"
                                                                                />   
                                                                              </div>
                                                                            )}                {/*Clicked overlay*/}

                          <div key={index} ref={panelDivRef} className='cfdal_calendar_lower_section_panel_div'>
                            {/*(multiplesOf9.includes(index)? (<div className='cfdal_timeSlots'>Q</div>): null)*/}
                            {([31,13,75].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([605,705,54].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([67,19,87].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([10,25,52].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([62,130,200].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Kevin" src='/images/kevin_systrom.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([235,213,279].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([242,194,262].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([160,173,143].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([312,325,355].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfdal_person_name_class'></p></div>): null}
                          </div>
                        </Grid>

                        ):(

                        <Grid key={index} xs={4.05} onClick={() => handleGridClick(index)} onMouseOver={() => handleMouseOver(index)} onMouseOut={handleMouseOut} className="cfdal_calendar_lower_section_minute_line_panel_grid">
                          {(hoveredGrid.includes(index)) && (<div className="cfdal_hovered_overlay" style={{height : `${6*heightOfCalendarGrid+3}px`}}><CgCheck className='cfdal_tick'/></div>)}  {/*Hovered overlay*/}
                          {(from1145pmTo12amHoveredGrid.includes(index)) && (<div className="cfdal_hovered_overlay" style={{height : `${5*heightOfCalendarGrid+3}px`}}><CgCheck className='cfdal_tick'/></div>)}     {/*Hovered overlay*/}
                          
                          {(clickedGrid.includes(index)) && (
                                                              <div className="cfdal_clicked_overlay" style={{height : `${6*heightOfCalendarGrid+3}px`}}>
                                                                <button onClick={() => setShowStrangersList(true)} className='cfdal_slot_book_any_button'> Book
                                                                </button>
                                                                <button onClick={() => setShowFriendsList(true)} className='cfdal_slot_book_friend_button'> Book with a friend
                                                                </button>
                                                                <div className="cfdal_enter_topic_message_div">Enter topic you wish to learn in the subject before booking</div>
                                                                <input
                                                                  type="text"
                                                                  placeholder="Enter topic if any..."
                                                                  value={topic}
                                                                  onChange={handleTopicChange}
                                                                  className="cfdal_topic_input"
                                                                />   
                                                              </div>
                                                            )}                {/*Clicked overlay*/}

                          {(from1145pmTo12amClickedGrid.includes(index)) && (
                                                                              <div className="cfdal_clicked_overlay" style={{height : `${5*heightOfCalendarGrid+3}px`}}>
                                                                                <button onClick={() => setShowStrangersList(true)} className='cfdal_slot_book_any_button'> Book
                                                                                </button>
                                                                                <button onClick={() => setShowFriendsList(true)} className='cfdal_slot_book_friend_button'> Book with a friend
                                                                                </button>
                                                                                <div className="cfdal_enter_topic_message_div">Enter topic you wish to learn in the subject before booking</div>
                                                                                <input
                                                                                  type="text"
                                                                                  placeholder="Enter topic if any..."
                                                                                  value={topic}
                                                                                  onChange={handleTopicChange}
                                                                                  className="cfdal_topic_input"
                                                                                />   
                                                                              </div>
                                                                            )}                {/*Clicked overlay*/}

                          <div key={index} ref={panelDivRef} className='cfdal_calendar_lower_section_panel_div'>
                            {/*(multiplesOf9.includes(index)? (<div className='cfdal_timeSlots'>Q</div>): null)*/}
                            {([31,13,75,605,705,54].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([605,705,54,67,19,87].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([67,19,87,10,25,52,31,13,75,24].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([10,25,52,62,130,200,67,19,87,10,25,52].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([62,130,200].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Kevin" src='/images/kevin_systrom.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([235,213,279,10,25,87].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([242,194,262].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([160,173,143,87,130,42].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfdal_person_name_class'></p></div>): null}
                            {([312,325,355,34].includes(index))  ? (<div className='cfdal_person_details_div'><Avatar className="cfdal_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfdal_person_name_class'></p></div>): null}
                          </div>
                        </Grid>
                        )
                      )
                  )
                }
              }
            )
          }
        </Grid>
      </Grid>
    </div>
  )
}

export default CalendarForDiscussAndLearn;

